module.exports = __webpack_public_path__ + "static/6-1208b03cd11a546762bde3b58eb884ac.jpg";